import React from 'react'
export const OutlookIcon: React.FC<{
  width?: string | number
  height?: string | number
}> = ({ width = '21', height = '19' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 21 19"
    fill="none"
    role="img"
    aria-label="Outlook Icon"
  >
    <title>Microsoft Outlook Logo</title>
    <path
      d="M20.7501 10.163C20.7512 10.0066 20.6704 9.86106 20.5371 9.77928H20.5347L20.5263 9.77463L13.5961 5.67231C13.5662 5.65209 13.5351 5.63361 13.5031 5.61696C13.2355 5.47892 12.9177 5.47892 12.6501 5.61696C12.618 5.63362 12.587 5.65209 12.557 5.67231L5.62683 9.77463L5.61847 9.77928C5.40666 9.911 5.34172 10.1895 5.47344 10.4013C5.51225 10.4637 5.5657 10.5157 5.62916 10.5528L12.5594 14.6551C12.5894 14.6751 12.6205 14.6936 12.6524 14.7104C12.92 14.8485 13.2379 14.8485 13.5054 14.7104C13.5374 14.6936 13.5684 14.6751 13.5985 14.6551L20.5287 10.5528C20.6671 10.4721 20.7517 10.3233 20.7501 10.163Z"
      fill="#0A2767"
    />
    <path
      d="M6.43454 7.42387H10.9824V11.5927H6.43454V7.42387ZM19.8196 3.1862V1.27922C19.8306 0.802436 19.4532 0.406933 18.9764 0.395508H7.17455C6.69776 0.406933 6.32036 0.802436 6.33129 1.27922V3.1862L13.308 5.04666L19.8196 3.1862Z"
      fill="#0364B8"
    />
    <path
      d="M6.33154 3.18628H10.9827V7.37232H6.33154V3.18628Z"
      fill="#0078D4"
    />
    <path
      d="M15.6336 3.18628H10.9824V7.37232L15.6336 11.5584H19.8196V7.37232L15.6336 3.18628Z"
      fill="#28A8EA"
    />
    <path
      d="M10.9824 7.37231H15.6336V11.5584H10.9824V7.37231Z"
      fill="#0078D4"
    />
    <path
      d="M10.9824 11.5583H15.6336V15.7444H10.9824V11.5583Z"
      fill="#0364B8"
    />
    <path
      d="M6.43457 11.5928H10.9825V15.3825H6.43457V11.5928Z"
      fill="#14447D"
    />
    <path
      d="M15.6338 11.5583H19.8198V15.7444H15.6338V11.5583Z"
      fill="#0078D4"
    />
    <path
      d="M20.5372 10.5272L20.5283 10.5318L13.5981 14.4299C13.5679 14.4485 13.5372 14.4662 13.5051 14.482C13.2359 14.6135 12.9212 14.6135 12.652 14.482C12.6202 14.4662 12.5891 14.4488 12.559 14.4299L5.62881 10.5323L5.62044 10.5272C5.48664 10.4546 5.40275 10.3152 5.40137 10.163V18.0532C5.4047 18.5795 5.83407 19.0035 6.36039 19.0002C6.36039 19.0002 6.36042 19.0002 6.36044 19.0002H19.7911C20.3175 19.0035 20.7468 18.5796 20.7502 18.0532C20.7502 18.0532 20.7502 18.0532 20.7502 18.0532V10.163C20.75 10.3139 20.6686 10.453 20.5372 10.5272Z"
      fill="url(#paint0_linear_2313_1264)"
    />
    <path
      opacity="0.5"
      d="M20.3779 10.1318V10.6155L13.1314 15.6048L5.62906 10.2946C5.62906 10.292 5.62697 10.2899 5.6244 10.2899L4.93604 9.87596V9.52711L5.21976 9.52246L5.81975 9.86665L5.8337 9.8713L5.88486 9.90386C5.88486 9.90386 12.936 13.9271 12.9546 13.9364L13.2244 14.0945C13.2476 14.0852 13.2709 14.0759 13.2988 14.0666C13.3128 14.0573 20.2988 10.1271 20.2988 10.1271L20.3779 10.1318Z"
      fill="#0A2767"
    />
    <path
      d="M20.5372 10.5272L20.5283 10.5323L13.5981 14.4299C13.5679 14.4485 13.5372 14.4662 13.5051 14.482C13.2359 14.6135 12.9212 14.6135 12.652 14.482C12.6202 14.4662 12.5891 14.4488 12.559 14.4299L5.62881 10.5323L5.62044 10.5272C5.48664 10.4546 5.40275 10.3152 5.40137 10.163V18.0532C5.4047 18.5795 5.83407 19.0035 6.36039 19.0002C6.36039 19.0002 6.36042 19.0002 6.36044 19.0002H19.7911C20.3175 19.0035 20.7468 18.5796 20.7502 18.0532C20.7502 18.0532 20.7502 18.0532 20.7502 18.0532V10.163C20.75 10.3139 20.6686 10.453 20.5372 10.5272Z"
      fill="#1490DF"
    />
    <path
      opacity="0.1"
      d="M13.699 14.3723L13.5953 14.4305C13.5653 14.4496 13.5342 14.4671 13.5023 14.483C13.388 14.5391 13.2638 14.572 13.1367 14.5798L15.7735 17.6979L20.373 18.8063C20.499 18.7111 20.5993 18.5859 20.6646 18.4421L13.699 14.3723Z"
      fill="black"
    />
    <path
      opacity="0.05"
      d="M14.1688 14.1082L13.5953 14.4305C13.5653 14.4496 13.5342 14.4672 13.5023 14.483C13.388 14.5391 13.2638 14.572 13.1367 14.5798L14.3721 17.9858L20.3744 18.8049C20.6108 18.6274 20.7501 18.349 20.7502 18.0533V17.9514L14.1688 14.1082Z"
      fill="black"
    />
    <path
      d="M6.37346 19.0002H19.7897C19.9962 19.0012 20.1975 18.936 20.3641 18.8141L12.7502 14.3541C12.7182 14.3381 12.6871 14.3202 12.6572 14.3006L5.63392 10.2923H5.63066L5.40137 10.163V18.0262C5.40084 18.5636 5.83606 18.9996 6.37346 19.0002Z"
      fill="#28A8EA"
    />
    <path
      opacity="0.1"
      d="M16.263 3.0385V16.8193C16.2619 17.3025 15.9683 17.7368 15.5206 17.9176C15.3819 17.9773 15.2325 18.0081 15.0816 18.0081H5.42969V2.50032H6.40039V1.85425H15.0816C15.7338 1.85672 16.2616 2.3858 16.263 3.0385Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M11.4479 5.43414V15.3551C11.449 15.4674 11.4252 15.5786 11.3781 15.6806C11.2489 15.999 10.9403 16.2079 10.5967 16.2095H5.40137V4.58158H10.5967C10.7317 4.58023 10.8647 4.61389 10.9828 4.67926C11.2679 4.8229 11.4478 5.11488 11.4479 5.43414Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M15.6216 3.6805V16.1792C15.6185 16.8322 15.0918 17.3614 14.4396 17.367H5.36523V2.49529L14.4395 2.49529C14.627 2.49341 14.8117 2.54021 14.9757 2.63109C15.3717 2.83078 15.6215 3.23668 15.6216 3.6805Z"
      fill="black"
    />
    <path
      opacity="0.2"
      d="M10.9828 5.43422V14.4249C10.9823 14.8953 10.602 15.277 10.1316 15.2793H5.40137V4.58167H10.1316C10.6019 4.58192 10.983 4.96342 10.9827 5.43376C10.9828 5.43391 10.9828 5.43407 10.9828 5.43422Z"
      fill="black"
    />
    <path
      d="M1.93568 2.49524H13.7951C14.4499 2.49524 14.9808 3.02609 14.9808 3.68092V15.5403C14.9808 16.1952 14.4499 16.726 13.7951 16.726H1.93568C1.28084 16.726 0.75 16.1952 0.75 15.5403V3.68092C0.75 3.02609 1.28086 2.49524 1.93568 2.49524Z"
      fill="url(#paint1_linear_2313_1264)"
    />
    <path
      d="M4.47692 7.47018C4.76737 6.85096 5.23619 6.33277 5.82319 5.98219C6.47325 5.60978 7.21341 5.42412 7.96217 5.44565C8.65614 5.43059 9.34091 5.60662 9.9417 5.95451C10.5066 6.29158 10.9615 6.78547 11.2513 7.37624C11.5669 8.02722 11.7242 8.74364 11.7104 9.46704C11.7257 10.2231 11.5638 10.9721 11.2378 11.6543C10.9411 12.2662 10.4717 12.7777 9.88769 13.1256C9.26375 13.4841 8.55355 13.6648 7.83423 13.648C7.12543 13.6651 6.42556 13.4871 5.81097 13.1333C5.24121 12.7958 4.78056 12.3013 4.484 11.709C4.16652 11.0674 4.00736 10.3591 4.01982 9.64329C4.00659 8.89371 4.16285 8.15084 4.47692 7.47018ZM5.9119 10.9634C6.06676 11.3549 6.32937 11.6944 6.66925 11.9425C7.01545 12.1846 7.42999 12.3096 7.85221 12.2989C8.30187 12.3167 8.74509 12.1876 9.1149 11.9309C9.45048 11.6836 9.70619 11.3431 9.85039 10.9518C10.0116 10.5148 10.0911 10.0518 10.0851 9.58605C10.09 9.11581 10.0153 8.64813 9.86388 8.20292C9.73019 7.80096 9.48273 7.44651 9.15154 7.18261C8.79101 6.91385 8.34897 6.77754 7.89978 6.79662C7.46841 6.78544 7.04458 6.91133 6.68918 7.15624C6.34355 7.40545 6.07596 7.74796 5.91769 8.14373C5.56659 9.05091 5.56476 10.0562 5.91254 10.9647L5.9119 10.9634Z"
      fill="white"
    />
    <path
      d="M15.6338 3.18628H19.8198V7.37232H15.6338V3.18628Z"
      fill="#50D9FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2313_1264"
        x1="13.0758"
        y1="10.163"
        x2="13.0758"
        y2="19.0002"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#35B8F1" />
        <stop offset="1" stopColor="#28A8EA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2313_1264"
        x1="3.22217"
        y1="1.56877"
        x2="12.5086"
        y2="17.6525"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1784D9" />
        <stop offset="0.5" stopColor="#107AD5" />
        <stop offset="1" stopColor="#0A63C9" />
      </linearGradient>
    </defs>
  </svg>
)
